import { useCallback } from 'react';

import { useBelow } from '@/hooks/useBelow';
import { openNewDesktopWindow } from '@/utils/helpers/window';

export const usePaymentWindow = () => {
  const isBelowDesktop = useBelow('desktop');
  const openPaymentWindow = useCallback(
    (url = '') => {
      if (!isBelowDesktop) {
        return openNewDesktopWindow();
      }
      return window.open(url, '_blank');
    },
    [isBelowDesktop]
  );

  return { openPaymentWindow };
};
